import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import formatDate from 'date-fns/format';
import minDate from 'date-fns/min';
import maxDate from 'date-fns/max';
import TextInput from "../../TextInput";
import styles from "../styles.pcss";
var cx = classNames.bind(styles);
var dateToString = function dateToString(date) {
  return date && formatDate(date, 'YYYY-MM-DD') || '';
};
var DateInputWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DateInputWrapper, _React$PureComponent);
  var _super = _createSuper(DateInputWrapper);
  function DateInputWrapper() {
    var _this;
    _classCallCheck(this, DateInputWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (dateStr) {
      if (!dateStr) {
        _this.props.onChange(null);
      } else {
        var date = new Date(dateStr);
        var validDate = maxDate(_this.props.min, minDate(date, _this.props.max));
        _this.props.onChange(validDate);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(TextInput, {
        className: cx('input', 'native', "".concat(_this.props.size, "Size")),
        disabled: _this.props.disabled,
        max: dateToString(_this.props.max),
        min: dateToString(_this.props.min),
        name: _this.props.name,
        onChange: _this.handleChange,
        onClick: _this.props.onClick,
        onFocus: _this.props.onFocus,
        placeholder: _this.props.placeholder,
        size: _this.props.size,
        status: _this.props.status,
        type: "date",
        value: dateToString(_this.props.value)
      });
    });
    return _this;
  }
  return _createClass(DateInputWrapper);
}(React.PureComponent);
_defineProperty(DateInputWrapper, "defaultProps", {
  value: null,
  min: null,
  max: null,
  name: null,
  status: null
});
export { DateInputWrapper as default };
DateInputWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  onFocus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string,
  size: PropTypes.oneOf(['default', 'big']).isRequired,
  status: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired
} : {};